import { RegexRule } from '@idm/react-forms';

// AIM-approved special character set only: ! # $ % & ' ( ) * + , - . / : ; < = > ? @ [ ] ^ _ { | } ~
const REGEX = /[!#$%&'()*+,\-./:;<=>?@[\]^_{|}~]/;

class SpecialCharRule extends RegexRule {
  constructor() {
    super(REGEX);
  }

  static get ruleName() {
    return 'special-char-required';
  }

  getDefaultMessage() {
    return 'Must contain a special character';
  }
}

export default SpecialCharRule;
